module.exports = __webpack_public_path__ + "static/media/ml.81be140f.png";